Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = '2.3.0-9';
//# sourceMappingURL=SearchkitVersion.js.map


// WEBPACK FOOTER //
// ./src/core/SearchkitVersion.js